module.exports = __webpack_public_path__ + "Roboto-Thin.ba422f71e799f3d29cbf.svg";


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/roboto-fontface/fonts/roboto/Roboto-Thin.svg
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-Thin.svg
// module chunks = styles